import { capitalize } from "lodash";
import { mapGetters } from "vuex";

export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['language', 'lang'])
  },
  methods:{
    /**
     * Extracts the product property based on the given property name and language strictness.
     * If langStrict is true, it returns the language-specific property value if it exists, or an empty string if it doesn't.
     * If langStrict is false, it tries to find the specified language-specific property if it exists,
     * otherwise it returns the default property value if it exists, or an empty string if neither exist.
     *
     * @param {string} prop - The name of the property to extract.
     * @param {boolean} langStrict - Determines the language strictness. If true, it only returns the language-specific property value if it exists. If false, it falls back to the default property value if the language-specific property doesn't exist.
     * @returns {string} - The extracted product property value.
     */
    extractProductProp(prop, langStrict) {
      const lang = this.config?.props?.[prop]?.lang || this.language;
      //const lang =  this.config?.props ? (this.config?.props[prop]?.lang || this.language) : this.language;
      //langStrict if true gets language locale only version of property if it exists, if false it tries to find either if specified language local doesn't exist
      const strict = this.product?.[`${prop}${capitalize(lang)}`] || this.product?.[prop];
      const loose = this.product?.[`${prop}En`] || this.product?.[`${prop}Fr`];
      if(langStrict) {
        return strict || '';
      }
      return strict || loose || '';
    },
  }
}
